import React from 'react'
import { observer } from 'mobx-react'
import PartnerModule from 'models/PartnerModule'
import { Checkbox } from 'antd'

type ListItemProps = {
    partnerId: string,
    item: any,
    step: any
}
const ListItem = ({ partnerId, item, step }: ListItemProps) => {
    if (partnerId && item?.id) {
        const title = PartnerModule.get_tile_title(partnerId, item, step.type)
        const subTitle = PartnerModule.get_tile_subtitle(partnerId, item, step.type)
        return <Checkbox value={item.id} key={item.id}
            className='list-item h-fit border-1 border-neutral-20 rounded-8 p-8 break-inside-avoid'>
            <div className='w-100% flex items-center overflow-auto'>
                {
                    PartnerModule.get_tile_icon(partnerId, item, step.type) && <figure className='inline-block mr-16' style={{ width: '22px', height: 'auto' }}>
                        <img alt='icon' src={PartnerModule.get_tile_icon(partnerId, item, step.type)} className='inline-block w-100% overflow-hidden' />
                    </figure>
                }
                <div className='flex-1 flex flex-col items-start text-left text-ellipsis overflow-hidden'>
                    {title && <h5 className='font-semibold'>{title}</h5>}
                    {subTitle && <h6>{subTitle}</h6>}
                </div>
            </div>
        </Checkbox>
    }
    return <></>
}

export default observer(ListItem)